(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["andrea-product-options"] && !Shopify.designMode) return;
  try {
    class AndreaProductOptions extends HTMLElement {
    connectedCallback() {
      const color = this.querySelector('[data-shirt-color]');
      const otherField = this.querySelector('[data-other-color-field]');
      const otherInput = this.querySelector('[data-other-color]');

      if (!color || !otherField || !otherInput) return;



      const updateOtherColor = () => {
        const showOther = color.value === 'Other';
        otherField.hidden = !showOther;
        otherInput.required = showOther;
        if (!showOther) otherInput.value = '';
      };

      color.addEventListener('change', updateOtherColor);
      updateOtherColor();
    }
  }

  if (!customElements.get('andrea-product-options')) {
    customElements.define('andrea-product-options', AndreaProductOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
